/**
 * Function takes a pathRule and pathname and checks if the paths
 * match. If the path contains a `*` it will act as a splat match and
 * return true for all paths that start with the substring matching
 * the rule.
 */
export const checkMatchPath = (pathRule: string, pathname: string) => {
  // Remove `/` from pathname if the last char is `/` except index page.
  const normalizedPathname =
    pathname.charAt(pathname.length - 1) === '/' && pathname.length > 1
      ? pathname.substring(0, pathname.length - 1)
      : pathname;

  /** substring doesn't include the last char,
   * if the last char is * we want to ignore it and see if the pathname of the pathRule matchLength matches.
   * If so, it is part of the splat match.
   */

  const matchlength = pathRule.length - 1;
  return (
    pathRule === normalizedPathname ||
    (pathRule.includes('*') && pathRule.substring(0, matchlength) === normalizedPathname.substring(0, matchlength))
  );
};
